export default "__VITE_ASSET__Bjz846xC__"